/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { DeploymentUpdateRequest } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState, StackDeployment } from '@modules/ui-types'

import { updateStackDeploymentRequest } from '@/reducers/asyncRequests/registry'

import { updateDeployment } from '../../../actions/stackDeployments'

import StackDeploymentName from './StackDeploymentName'

import type { ThunkDispatch, ReduxState } from '@/types/redux'

type StateProps = {
  updateStackDeploymentRequest: AsyncRequestState
}

type DispatchProps = {
  updateDeployment: (updateRequest: DeploymentUpdateRequest) => Promise<unknown>
}

type ConsumerProps = {
  deployment: StackDeployment
}

const mapStateToProps = (state: ReduxState, { deployment }: ConsumerProps): StateProps => ({
  updateStackDeploymentRequest: updateStackDeploymentRequest(state, deployment.id),
})

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { deployment }: ConsumerProps,
): DispatchProps => ({
  updateDeployment: (updateRequest: DeploymentUpdateRequest) =>
    dispatch(
      updateDeployment({
        deploymentId: deployment.id,
        deployment: updateRequest,
        redirect: false,
      }),
    ),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(StackDeploymentName)
